import * as types from "./memberIdentifierRecoveryActionTypes";

export default function memberIdentifierRecoveryReducer(state = {}, action) {
  switch (action.type) {
    case types.CLEAR: {
      const newData = { [action.model.name]: {} };
      return { ...state, ...newData };
    }

    case types.FETCH: {
      const newData = { [action.payload.model.name]: { loaded: false } };
      return { ...state, ...newData };
    }
    case types.FETCH_FAILURE: {
      const newData = {
        [action.payload.model.name]: { ...action.payload, loaded: true },
      };
      return { ...state, ...newData };
    }
    case types.FETCH_SUCCESS: {
      const newData = {
        [action.payload.model.name]: { ...action.payload.data, loaded: true },
      };
      return { ...state, ...newData };
    }

    case types.RECOVER_IDENTIFIER: {
      const newData = { recovering: { submitting: true, completed: false } };
      return { ...state, ...newData };
    }
    case types.RECOVER_IDENTIFIER_FAILURE:
    case types.RECOVER_IDENTIFIER_SUCCESS: {
      const newData = {
        recovering: { ...action.payload, submitting: false, completed: true },
      };
      return { ...state, ...newData };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/member-identifier-recovery/memberIdentifierRecoveryReducer.js